import { Injectable, signal } from '@angular/core';

interface PresenceMember {
  id: string;
  info: {
    name: string;
    tenantId: string;
    tenantName: string;
    terminalId?: string | null;
    role?: string;
  };
}

interface TenantPresence {
  tenantId: string;
  tenantName: string;
  onlineUsers: PresenceMember[];
}

/**
 * Service to share workspace data (like online users) between workspace layout and child components
 */
@Injectable({
  providedIn: 'root',
})
export class WorkspaceDataService {
  // Online users data
  onlineUsersCount = signal<number>(0);
  tenantPresence = signal<TenantPresence[]>([]);
  currentTenantId = signal<string | null>(null);

  updateOnlineUsers(count: number, presence: TenantPresence[], tenantId: string | null) {
    this.onlineUsersCount.set(count);
    this.tenantPresence.set(presence);
    this.currentTenantId.set(tenantId);
  }
}
